import { AttributeInput } from "services/interface";
import styled from "@emotion/styled";
import { FormInstance, Row, UploadFile } from "antd";
import { FC, useEffect, useState } from "react";
import type { UploadFile as AntdUploadFile } from "antd/es/upload/interface";
import ProductAtributteCard from "../CreateProduct/ProductAttributeCard";
import ProductCategoryCard from "../CreateProduct/ProductCategoryCard";
import ProductDescriptionForm from "../CreateProduct/ProductDescriptionForm";
import ProductImageCard from "../CreateProduct/ProductImageCard";
//import ProductImageDesCard from "../CreateProduct/ProductImageDesCard";
import ProductNameForm from "../CreateProduct/ProductNameForm";
// ระบบเก่า - ProductVariationCard (2-step)
// import ProductVariationCard from "../CreateProduct/ProductVariationCard";
// ระบบใหม่ - ProductSKUCard (single-step)
import ProductSKUCard from "../CreateProduct/ProductSKUCard";
import ProductRecommendForm from "../CreateProduct/ProductRecommendForm";
import ProductOpenSaleForm from "../CreateProduct/ProductOpenSale";
import ProductRetailTypeCard from "../CreateProduct/ProductRetailTypeCard";
import ProductIsRecommend from "../CreateProduct/ProductIsRecommend";
import ProductTagname from "../CreateProduct/ProductTagname";

import ProductSGImportantAdviceForm from "../CreateProduct/ProductSGImportantAdviceForm";
import ProductSGRecommendedShop from "../CreateProduct/ProductSGRecommendedShop";
import ProductSGFrequentlyQnA from "../CreateProduct/ProductSGFrequentlyQnA";
import ProductSGSalesIncome from "../CreateProduct/ProductSGSalesIncome";
import ProductSGInviteSale from "../CreateProduct/ProductSGInviteSale";
import ProductSGWaitingTime from "../CreateProduct/ProductSGWaitingTime";
import { useAppSelector } from "store";

interface MainUpdateProductProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  attribute: AttributeInput[];
  setAttribute: (attribute: AttributeInput[]) => void;
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  prices: PricesInput;
  setPrices: (prices: PricesInput) => void;
  images: UploadFile[] | undefined;
  checkIsActive: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
  setCheckIsRecommend: (checkIsRecommend: boolean) => void;
  checkIsRecommend: boolean;
  checkIsApproved: boolean;
  setCheckIsApproved: (checkIsApproved: boolean) => void;
  checkIsShowApp: boolean;
  setCheckIsShowApp: (checkIsShowApp: boolean) => void;
  setIsUpdateButtonDisabled: (disabled: boolean) => void;
  originalPrices: PricesInput; // ✅ เก็บค่าจากฐานข้อมูลเพื่อใช้สำหรับ restore c1-c3
  originalVariants: VariantsInput; // ✅ เก็บค่าจากฐานข้อมูลเพื่อใช้ restore shipping_method + dimensions
  factoryId?: string; // ✅ รับ factoryId
  productId?: string; // ✅ รับ productId
}

const MainUpdateProduct: FC<MainUpdateProductProps> = ({
  form,
  attribute,
  setAttribute,
  setVariants,
  variants,
  prices,
  setPrices,
  images,
  checkIsActive,
  setCheckIsActive,
  checkIsRecommend,
  setCheckIsRecommend,
  checkIsApproved,
  setCheckIsApproved,
  checkIsShowApp,
  setCheckIsShowApp,
  setIsUpdateButtonDisabled,
  originalPrices,
  originalVariants,
  factoryId,
  productId,
}) => {
  // ✅ เพิ่ม state สำหรับ SKU Image (เหมือนในหน้าเพิ่มสินค้า)
  const [skuImage, setSkuImage] = useState<AntdUploadFile[] | undefined>([]);

  useEffect(() => {
    console.log("🔄 skuImageM:", skuImage);
  }, [skuImage]);

  const { contact } = useAppSelector((state) => state.auth);

  // ✅ useEffect สำหรับ disabled ปุ่มอัพเดท — เฉพาะเมื่อเปิดการขายแต่ยังไม่มี SKU
  useEffect(() => {
    const hasNoSKUs = variants.length === 0 && prices.length === 0;
    setIsUpdateButtonDisabled(checkIsActive && hasNoSKUs);
  }, [variants, prices, checkIsActive, setIsUpdateButtonDisabled]);

  return (
    <FormWrapper>
      {images && (
        <ProductImageCard
          is_active={checkIsActive}
          setCheckIsActive={setCheckIsActive}
          isEditMode={true}
          variants={variants}
        />
      )}
      <FormItemWrapper style={{ paddingTop: 10 }}>
        <ProductNameForm is_active={true} />
      </FormItemWrapper>
      <FormItemWrapper style={{ padding: 0 }}>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          <ProductCategoryCard is_active={checkIsActive} />
          <ProductRetailTypeCard is_active={checkIsActive} />
        </Row>
      </FormItemWrapper>

      <FormItemWrapper>
        {/* <ProductOpenSaleForm setCheckIsActive={setCheckIsActive} /> */}

        {/* ระบบเก่า - ProductVariationCard (2-step) 
          <ProductVariationCard
            setVariants={setVariants}
            variants={variants}
            prices={prices}
            setPrices={setPrices}
          />
          */}
        {/* ระบบใหม่ - ProductSKUCard (single-step) — tabs สินค้า/คลัง อยู่ใน header ของ card นี้ */}
        <ProductSKUCard
          setVariants={setVariants}
          variants={variants}
          prices={prices}
          setPrices={setPrices}
          skuImage={skuImage}
          setSkuImage={setSkuImage}
          isEditMode={true}
          setCheckIsActive={setCheckIsActive}
          form={form}
          originalPrices={originalPrices}
          originalVariants={originalVariants}
          factoryId={factoryId}
          productId={productId}
        />

        {/*สินค้าแนะนำ / สินค้าค้างสต๊อก*/}
        <div style={{ height: 10 }}></div>
        <ProductIsRecommend
          is_recommend={checkIsRecommend}
          setCheckIsRecommend={setCheckIsRecommend}
          checkIsActive={checkIsActive}
          setCheckIsActive={setCheckIsActive}
          checkIsApproved={checkIsApproved}
          setCheckIsApproved={setCheckIsApproved}
          checkIsShowApp={checkIsShowApp}
          setCheckIsShowApp={setCheckIsShowApp}
        />

        {/*เครื่องมือสื่อสาร (Media Kit)*/}
        <ProductRecommendForm />

        {/*คำแนะนำสำคัญ*/}
        <ProductSGImportantAdviceForm is_active={true} />
        <ProductDescriptionForm is_active={true} />

        {/*ระยะเวลารอรับสินค้า*/}
        <ProductSGWaitingTime is_active={true} />

        {/*แนะนำร้านค้าเป้าหมาย*/}
        <ProductSGRecommendedShop is_active={true} />
        {/*คำถามที่พบบ่อยเกี่ยวกับตัวสินค้า*/}
        <ProductSGFrequentlyQnA is_active={true} />
        {/*กำไรและราคาแนะนำ (Business Guide) – ช่วยให้ตัวแทนวางแผนได้*/}
        <ProductSGSalesIncome is_active={true} />

        {/*แผนสร้างการซื้อซ้ำ (Repeat Plan) – วิธีทำให้ลูกค้ากลับมาซื้ออีก*/}
        <ProductSGInviteSale is_active={true} />
      </FormItemWrapper>
      {/* <ProductImageDesCard /> */}
      <FormItemWrapper style={{ paddingBottom: 20 }}>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          {/*quickwin*/}
          {contact?.code === "lunganek" && <ProductTagname />}
          {contact?.code === "lunganek" && (
            <ProductAtributteCard
              attribute={attribute}
              setAttribute={setAttribute}
            />
          )}
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  );
};

export default MainUpdateProduct;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
